/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function o(o,t,e,n,c){console.timeStamp(o,t,e,c,n)}export{o as recordPerformance};
